import BtnDelSvg from './btn-del-svg'
import BtnEditSvg from './btn-edit-svg';

const TaskClosedField = ({ MYID, id, tagsData, data, deleteQuestionFromComplex, editQuestionInComplex }) => {
    const tagKeys = Object.keys(tagsData);
    const tagValues = Object.values(tagsData);
    const typeStr = (type) => {
        switch (type) {
            case '1': {
                return 'выбор одного варианта';
                break;
            }
            case '2': {
                return 'выбор нескольких вариантов';
                break;
            }
            case '3': {
                return 'длинный ответ';
                break;
            }
            case '4': {
                return 'короткий ответ';
                break;
            }
            case '5': {
                return 'ассоциации';
                break;
            }
            case '6': {
                return 'пропуски в тексте';
                break;
            }
            case '7': {
                return 'составление последовательности';
                break;
            }
            default: {
                return 'без типа';
            }
        }
    }
    const strToColor = (str) => {
        var count = 0;
        str.split('').map((symb) => {
            count += symb.charCodeAt(0);
        })
        count = count * 4 % 360;
        return 'hsl(' + count + ' 40% 70%)';
    }

    return (
        <div id={'q' + id} className='taskcr-main-content-block'>
            <div className='taskcr-closed-block'>
                <div className='taskcr-num-block'>
                    <div className='taskcr-num'>
                        {id}
                    </div>
                </div>
                <div className='taskcr-closed-block-left'>
                    <div className='taskcr-closed-block-type'>
                        <div className='taskcr-closed-block-tag taskcr-type-color'>
                            {typeStr(data.type.toString())}
                        </div>
                        
                    </div>
                    <div className='taskcr-closed-block-name'>
                        {data.description}
                    </div>
                    <div className='taskcr-closed-block-type'>
                        {tagValues.map((item1) => {
                            return item1.map((item2) => {
                                if (data.tags.includes(item2.id)) {
                                    return (
                                        <div key={item2.id} style={{ color: strToColor(item2.name.toString()) }} className='taskcr-closed-block-tag'>
                                            {item2.name}
                                        </div>
                                    )
                                }
                            })
                        })}
                    </div>
                </div>
                <div className='tasckcr-closed-btn-del'>
                    <button className='taskcr-btn-del' onClick={() => editQuestionInComplex(MYID, data.id)}><BtnEditSvg /></button>
                </div>
                <div className='tasckcr-closed-btn-del'>
                    <button className='taskcr-btn-del' onClick={() => deleteQuestionFromComplex(MYID, data.id)}><BtnDelSvg /></button>
                </div>
            </div>
        </div>
    )
}

export default TaskClosedField;